export const ReportConstants = {
  DOWNLOAD_USER_REQUEST: "DOWNLOAD_USER_REQUEST",
  DOWNLOAD_USER_SUCCESS: "DOWNLOAD_USER_SUCCESS",
  DOWNLOAD_USER_FAILURE: "DOWNLOAD_USER_FAILURE",
  FETCH_RENEWAL_REPORT_REQUEST: "FETCH_RENEWAL_REPORT_REQUEST",
  FETCH_RENEWAL_REPORT_SUCCESS: "FETCH_RENEWAL_REPORT_SUCCESS",
  FETCH_RENEWAL_REPORT_FAILURE: "FETCH_RENEWAL_REPORT_FAILURE",
  FETCH_STATIC_IP_REPORT_REQUEST: "FETCH_STATIC_IP_REPORT_REQUEST",
  FETCH_STATIC_IP_REPORT_SUCCESS: "FETCH_STATIC_IP_REPORT_SUCCESS",
  FETCH_STATIC_IP_REPORT_FAILURE: "FETCH_STATIC_IP_REPORT_FAILURE",
  FETCH_UPDATE_DATA_LIMIT_REPORT_REQUEST: "FETCH_UPDATE_DATA_LIMIT_REPORT_REQUEST",
  FETCH_UPDATE_DATA_LIMIT_REPORT_SUCCESS: "FETCH_UPDATE_DATA_LIMIT_REPORT_SUCCESS",
  FETCH_UPDATE_DATA_LIMIT_REPORT_FAILURE: "FETCH_UPDATE_DATA_LIMIT_REPORT_FAILURE",
  FETCH_VALIDITY_REPORT_REQUEST: "FETCH_VALIDITY_REPORT_REQUEST",
  FETCH_VALIDITY_REPORT_SUCCESS: "FETCH_VALIDITY_REPORT_SUCCESS",
  FETCH_VALIDITY_REPORT_FAILURE: "FETCH_VALIDITY_REPORT_FAILURE",
  FETCH_PAYMENT_GATEWAY_REPORT_REQUEST: "FETCH_PAYMENT_GATEWAY_REPORT_REQUEST",
  FETCH_PAYMENT_GATEWAY_REPORT_SUCCESS: "FETCH_PAYMENT_GATEWAY_REPORT_SUCCESS",
  FETCH_PAYMENT_GATEWAY_REPORT_FAILURE: "FETCH_PAYMENT_GATEWAY_REPORT_FAILURE",
  FETCH_DEPOSIT_PAYMENT_GATEWAY_REPORT_REQUEST: "FETCH_DEPOSIT_PAYMENT_GATEWAY_REPORT_REQUEST",
  FETCH_DEPOSIT_PAYMENT_GATEWAY_REPORT_SUCCESS: "FETCH_DEPOSIT_PAYMENT_GATEWAY_REPORT_SUCCESS",
  FETCH_DEPOSIT_PAYMENT_GATEWAY_REPORT_FAILURE: "FETCH_DEPOSIT_PAYMENT_GATEWAY_REPORT_FAILURE",
  FETCH_DUE_REPORT_REQUEST: "FETCH_DUE_REPORT_REQUEST",
  FETCH_DUE_REPORT_SUCCESS: "FETCH_DUE_REPORT_SUCCESS",
  FETCH_DUE_REPORT_FAILURE: "FETCH_DUE_REPORT_FAILURE",
  FETCH_HOLD_REPORT_REQUEST: "FETCH_HOLD_REPORT_REQUEST",
  FETCH_HOLD_REPORT_SUCCESS: "FETCH_HOLD_REPORT_SUCCESS",
  FETCH_HOLD_REPORT_FAILURE: "FETCH_HOLD_REPORT_FAILURE",
  FETCH_COMBO_REPORT_REQUEST: "FETCH_COMBO_REPORT_REQUEST",
  FETCH_COMBO_REPORT_SUCCESS: "FETCH_COMBO_REPORT_SUCCESS",
  FETCH_COMBO_REPORT_FAILURE: "FETCH_COMBO_REPORT_FAILURE",
  FETCH_COLLECTION_REPORT_REQUEST: "FETCH_COLLECTION_REPORT_REQUEST",
  FETCH_COLLECTION_REPORT_SUCCESS: "FETCH_COLLECTION_REPORT_SUCCESS",
  FETCH_COLLECTION_REPORT_FAILURE: "FETCH_COLLECTION_REPORT_FAILURE",
  FETCH_WALLET_REQUEST: "FETCH_WALLET_REQUEST",
  FETCH_WALLET_SUCCESS: "FETCH_WALLET_SUCCESS",
  FETCH_WALLET_FAILURE: "FETCH_WALLET_FAILURE",
  FETCH_SHARING_REPORT_REQUEST: "FETCH_SHARING_REPORT_REQUEST",
  FETCH_SHARING_REPORT_SUCCESS: "FETCH_SHARING_REPORT_SUCCESS",
  FETCH_SHARING_REPORT_FAILURE: "FETCH_SHARING_REPORT_FAILURE",
  FETCH_WALLET_SUM_REQUEST: "FETCH_WALLET_SUM_REQUEST",
  FETCH_WALLET_SUM_SUCCESS: "FETCH_WALLET_SUM_SUCCESS",
  FETCH_WALLET_SUM_FAILURE: "FETCH_WALLET_SUM_FAILURE",
  DOWNLOAD_VALIDITY_REPORT_REQUEST: "DOWNLOAD_VALIDITY_REPORT_REQUEST",
  DOWNLOAD_VALIDITY_REPORT_SUCCESS: "DOWNLOAD_VALIDITY_REPORT_SUCCESS",
  DOWNLOAD_VALIDITY_REPORT_FAILURE: "DOWNLOAD_VALIDITY_REPORT_FAILURE",
  DOWNLOAD_STATIC_IP_REPORT_REQUEST: "DOWNLOAD_STATIC_IP_REPORT_REQUEST",
  DOWNLOAD_STATIC_IP_REPORT_SUCCESS: "DOWNLOAD_STATIC_IP_REPORT_SUCCESS",
  DOWNLOAD_STATIC_IP_REPORT_FAILURE: "DOWNLOAD_STATIC_IP_REPORT_FAILURE",
};
